/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 03/12/21
 */

import { useContext } from 'react';
import { AuthContext } from './AuthProvider';

export const useAuth = () => {
    return useContext(AuthContext);
};
